import { render, staticRenderFns } from "./HorseRace.vue?vue&type=template&id=84e5417c&"
import script from "./HorseRace.vue?vue&type=script&lang=js&"
export * from "./HorseRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports